// extracted by mini-css-extract-plugin
module.exports = {"sharePopover":"eB","shareText":"eC","show":"eD"};